"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULED_VISIT_REMINDER_RULE_ID = exports.WHATSAPP_VISIT_BUTTON_ACTIONS = exports.WHATSAPP_AUTOMATION_PARAMETER_SOURCES = void 0;
exports.WHATSAPP_AUTOMATION_PARAMETER_SOURCES = [
    'lead.name',
    'lead.phone',
    'stage.label',
    'visit.time',
    'visit.address',
    'portal.url',
];
exports.WHATSAPP_VISIT_BUTTON_ACTIONS = [
    'visit.confirm',
    'visit.change_time',
    'visit.cancel_request',
];
exports.SCHEDULED_VISIT_REMINDER_RULE_ID = 'scheduled_visit_reminder';
